// @ts-nocheck
import useSWR from 'swr';

import { fetchModels, fetchSegmentsExperimental } from 'src/store/api';
import CONSTANTS from 'src/store/constants';

async function fetchModelsWithConfig(q, o, { includeRefresh }) {
  const models = await fetchModels(q, o);

  if (includeRefresh) {
    const segmentTypeMap = CONSTANTS.TAL_MODEL.SEGMENT_TYPE;
    const segmentMap = {};
    // Retrieve segments referenced in the modelData field
    for (const model of models) {
      const dataPayload = model?.modelData?.dataPayload ?? null;
      const id = model?.id ?? null;
      if (dataPayload) {
        Object.entries(dataPayload).forEach(([key, value]) => {
          if (key.includes('segment_id') && value) {
            if (!segmentMap[value]) segmentMap[value] = [segmentTypeMap[key], [id]];
            else {
              segmentMap[value][1].push(id);
            }
          }
        });
      }
    }
    const segmentIds = Object.keys(segmentMap);
    const segmentOptions = {
      headers: {
        'X-Fields': 'items{id,name,refresh{id,name,platform}}',
      },
    };
    const segmentQuery = {
      filters: [
        {
          name: 'id',
          op: 'in',
          val: segmentIds,
        },
      ],
    };
    const segments = await fetchSegmentsExperimental(segmentQuery, segmentOptions);
    // walk the results and set segment refresh
    segments.forEach((segmentData) => {
      const { id: segmentId } = segmentData;
      const [, modelIds] = segmentMap[segmentId];
      modelIds.forEach((modelId) => {
        const modelIdx = models.findIndex((model) => +model.id === +modelId);
        models[modelIdx].refresh = segmentData.refresh;
      });
    });
  }

  return models;
}

export default function useModels({ query, options = {}, config = {} }) {
  const { shouldFetch = true } = config;

  const url = `/core/v2/thinkalike_model?query=${JSON.stringify(query)}&config=${JSON.stringify(config)}`;
  const { fields = '*', ...requestQuery } = query;
  const requestOptions = {
    headers: {
      'X-Fields': fields,
    },
    ...options,
  };

  return useSWR(
    shouldFetch ? { key: url, requestQuery, requestOptions } : null,
    ({ requestQuery: q, requestOptions: o }) => fetchModelsWithConfig(q, o, config),
    {
      revalidateIfStale: config.revalidateIfStale || false,
      revalidateOnMount: config.revalidateOnMount || false,
      revalidateOnFocus: config.revalidateOnFocus || false,
    }
  );
}
